var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.hasRoutes
        ? _c(
            "box",
            {
              attrs: {
                background: "white",
                "custom-class": "expansion-box",
                "no-shadow": ""
              }
            },
            [
              _c(
                "div",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("download", {
                    attrs: { "map-view-data": _vm.mapViewData }
                  }),
                  _vm._v(" "),
                  _c("share", { attrs: { url: _vm.shareUrl } }),
                  _vm._v(" "),
                  _c("print", { attrs: { "map-view-data": _vm.mapViewData } }),
                  _vm._v(" "),
                  _c("h3", [
                    _vm._v(_vm._s(_vm.$t("routeDetails.routeDetails")))
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _vm.hasRoutes
                ? _c(
                    "v-expansion-panel",
                    {
                      staticClass: "no-shadow",
                      attrs: {
                        slot: "content",
                        value: _vm.startedPanelExtended
                      },
                      slot: "content"
                    },
                    _vm._l(_vm.parsedRoutes, function(route, routeIndex) {
                      return _c(
                        "v-expansion-panel-content",
                        {
                          key: routeIndex,
                          staticClass: "routes-header",
                          staticStyle: { background: "transparent" }
                        },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "header" }, slot: "header" },
                            [
                              _c(
                                "h4",
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("routeDetails.route")) +
                                      " " +
                                      _vm._s(routeIndex + 1) +
                                      " (" +
                                      _vm._s(route.summary.distance) +
                                      ")\n            "
                                  ),
                                  _vm.parsedRoutes.length > 1
                                    ? _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            icon: "",
                                            title:
                                              routeIndex ===
                                              _vm.$store.getters
                                                .activeRouteIndex
                                                ? _vm.$t(
                                                    "routeDetails.selectedRoute"
                                                  )
                                                : _vm.$t(
                                                    "routeDetails.selectRoute"
                                                  )
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.changeActiveRouteIndex(
                                                routeIndex
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: {
                                                color:
                                                  routeIndex ===
                                                  _vm.$store.getters
                                                    .activeRouteIndex
                                                    ? "primary"
                                                    : "dark"
                                              }
                                            },
                                            [_vm._v("done")]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list",
                            [
                              _c("v-divider"),
                              _vm._v(" "),
                              _c(
                                "v-list",
                                {
                                  staticClass: "route-details",
                                  attrs: { dense: "" }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { padding: "0 0 0 10px" } },
                                    [
                                      _c("div", [
                                        _vm._v(
                                          _vm._s(_vm.$t("global.distance")) +
                                            ":  "
                                        ),
                                        _c("b", [
                                          _vm._v(
                                            _vm._s(route.summary.distance) + " "
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      route.summary.duration
                                        ? _c("div", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("global.duration")
                                              ) + ":  "
                                            ),
                                            _c("b", [
                                              _vm._v(
                                                _vm._s(route.summary.duration) +
                                                  " "
                                              )
                                            ])
                                          ])
                                        : _vm._e()
                                    ]
                                  ),
                                  _vm._v(" "),
                                  route.properties.warnings
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: { padding: "0 0 0 10px" }
                                        },
                                        [
                                          _c("h4", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("routeDetails.warnings")
                                              ) + ":"
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _vm._l(
                                            route.properties.warnings,
                                            function(warning) {
                                              return _c(
                                                "v-alert",
                                                {
                                                  key: warning.code,
                                                  staticStyle: {
                                                    color: "black"
                                                  },
                                                  attrs: {
                                                    value: _vm.getWarningTranslated(
                                                      warning
                                                    ),
                                                    type: "warning"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.getWarningTranslated(
                                                        warning
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            }
                                          )
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  route.properties.segments.length > 1 &&
                                  routeIndex ===
                                    _vm.$store.getters.activeRouteIndex
                                    ? _c(
                                        "div",
                                        { staticClass: "route-container" },
                                        [
                                          _vm.hasRoutes
                                            ? _c(
                                                "v-expansion-panel",
                                                {
                                                  staticClass: "no-shadow",
                                                  attrs: {
                                                    value:
                                                      route.properties.segments
                                                        .length === 1
                                                        ? 0
                                                        : null
                                                  }
                                                },
                                                _vm._l(
                                                  route.properties.segments,
                                                  function(
                                                    segment,
                                                    segmentIndex
                                                  ) {
                                                    return _c(
                                                      "v-expansion-panel-content",
                                                      {
                                                        key: segmentIndex,
                                                        staticClass:
                                                          "route-panel"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            attrs: {
                                                              slot: "header"
                                                            },
                                                            slot: "header"
                                                          },
                                                          [
                                                            _c("h4", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "routeDetails.segment"
                                                                  )
                                                                ) +
                                                                  " " +
                                                                  _vm._s(
                                                                    segmentIndex +
                                                                      1
                                                                  )
                                                              )
                                                            ])
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "v-list",
                                                          [
                                                            _c("v-divider"),
                                                            _vm._v(" "),
                                                            _c(
                                                              "v-list",
                                                              {
                                                                staticClass:
                                                                  "instructions-scroll",
                                                                attrs: {
                                                                  dense: ""
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticStyle: {
                                                                      padding:
                                                                        "0 0 0 0px"
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      [
                                                                        _vm._v(
                                                                          "\n                          " +
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                "global.distance"
                                                                              )
                                                                            ) +
                                                                            ":  "
                                                                        ),
                                                                        _c(
                                                                          "b",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                segment.distance
                                                                              ) +
                                                                                " "
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "v-btn",
                                                                          {
                                                                            staticStyle: {
                                                                              height:
                                                                                "15px"
                                                                            },
                                                                            attrs: {
                                                                              "max-width": 30,
                                                                              fab:
                                                                                "",
                                                                              icon:
                                                                                "",
                                                                              small:
                                                                                "",
                                                                              title: _vm.$t(
                                                                                "routeDetails.gotoSegment"
                                                                              )
                                                                            },
                                                                            on: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                return _vm.segmentClicked(
                                                                                  segment,
                                                                                  segmentIndex
                                                                                )
                                                                              }
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "v-icon",
                                                                              [
                                                                                _vm._v(
                                                                                  "remove_red_eye"
                                                                                )
                                                                              ]
                                                                            )
                                                                          ],
                                                                          1
                                                                        )
                                                                      ],
                                                                      1
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c("div", [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "global.duration"
                                                                          )
                                                                        ) +
                                                                          ":  "
                                                                      ),
                                                                      _c("b", [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            segment.duration
                                                                          ) +
                                                                            " "
                                                                        )
                                                                      ])
                                                                    ]),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "v-layout",
                                                                      [
                                                                        segment.ascent
                                                                          ? _c(
                                                                              "v-flex",
                                                                              {
                                                                                attrs: {
                                                                                  sm6:
                                                                                    ""
                                                                                }
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "p",
                                                                                  [
                                                                                    _c(
                                                                                      "v-icon",
                                                                                      [
                                                                                        _vm._v(
                                                                                          "arrow_upward"
                                                                                        )
                                                                                      ]
                                                                                    ),
                                                                                    _vm._v(
                                                                                      " " +
                                                                                        _vm._s(
                                                                                          _vm.formatElevation(
                                                                                            segment.ascent
                                                                                          )
                                                                                        ) +
                                                                                        " " +
                                                                                        _vm._s(
                                                                                          _vm.$t(
                                                                                            "global.units.m"
                                                                                          )
                                                                                        )
                                                                                    )
                                                                                  ],
                                                                                  1
                                                                                )
                                                                              ]
                                                                            )
                                                                          : _vm._e(),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        segment.descent
                                                                          ? _c(
                                                                              "v-flex",
                                                                              {
                                                                                attrs: {
                                                                                  sm6:
                                                                                    ""
                                                                                }
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "p",
                                                                                  [
                                                                                    _c(
                                                                                      "v-icon",
                                                                                      [
                                                                                        _vm._v(
                                                                                          "arrow_downward"
                                                                                        )
                                                                                      ]
                                                                                    ),
                                                                                    _vm._v(
                                                                                      " " +
                                                                                        _vm._s(
                                                                                          _vm.formatElevation(
                                                                                            segment.descent
                                                                                          )
                                                                                        ) +
                                                                                        " " +
                                                                                        _vm._s(
                                                                                          _vm.$t(
                                                                                            "global.units.m"
                                                                                          )
                                                                                        )
                                                                                    )
                                                                                  ],
                                                                                  1
                                                                                )
                                                                              ]
                                                                            )
                                                                          : _vm._e()
                                                                      ],
                                                                      1
                                                                    )
                                                                  ],
                                                                  1
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticStyle: {
                                                                      padding:
                                                                        "0 0 0 0px"
                                                                    }
                                                                  },
                                                                  [
                                                                    _c("h4", [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "routeDetails.instructions"
                                                                          )
                                                                        ) + ":"
                                                                      )
                                                                    ]),
                                                                    _vm._v(" "),
                                                                    _c("br"),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "steps",
                                                                      {
                                                                        attrs: {
                                                                          steps:
                                                                            segment.steps
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  }
                                                ),
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("route-extras", {
                                            attrs: { route: route }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "padding-left": "5px",
                                                "padding-right": "30px",
                                                "padding-top": "10px"
                                              }
                                            },
                                            [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "routeDetails.routeOpacity"
                                                    )
                                                  )
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("v-slider", {
                                                staticClass:
                                                  "route-opacity-slider",
                                                attrs: {
                                                  min: 0,
                                                  max: 1,
                                                  "append-icon": "opacity",
                                                  "thumb-size": 24,
                                                  "thumb-label": "always",
                                                  title: _vm.$t(
                                                    "routeDetails.routeOpacity"
                                                  ),
                                                  step: 0.1
                                                },
                                                on: {
                                                  change: function($event) {
                                                    return _vm.routeOpacityChanged(
                                                      routeIndex
                                                    )
                                                  }
                                                },
                                                model: {
                                                  value:
                                                    route.properties.opacity,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      route.properties,
                                                      "opacity",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "route.properties.opacity"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : routeIndex ===
                                      _vm.$store.getters.activeRouteIndex
                                    ? _c(
                                        "div",
                                        { staticClass: "route-container" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                padding: "0 0 0 5px"
                                              }
                                            },
                                            [
                                              _vm.hasRoutes
                                                ? _c(
                                                    "v-expansion-panel",
                                                    {
                                                      staticClass: "no-shadow",
                                                      attrs: { value: null }
                                                    },
                                                    [
                                                      _c(
                                                        "v-expansion-panel-content",
                                                        {
                                                          staticClass:
                                                            "route-panel",
                                                          staticStyle: {
                                                            background:
                                                              "transparent"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              attrs: {
                                                                slot: "header"
                                                              },
                                                              slot: "header"
                                                            },
                                                            [
                                                              _c("h4", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "routeDetails.instructions"
                                                                    )
                                                                  )
                                                                )
                                                              ])
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-list",
                                                            {
                                                              staticClass:
                                                                "instructions-scroll"
                                                            },
                                                            [
                                                              _c("v-divider"),
                                                              _vm._v(" "),
                                                              _c(
                                                                "v-list",
                                                                {
                                                                  attrs: {
                                                                    dense: ""
                                                                  }
                                                                },
                                                                [
                                                                  _c("steps", {
                                                                    attrs: {
                                                                      steps:
                                                                        route
                                                                          .properties
                                                                          .segments[0]
                                                                          .steps
                                                                    }
                                                                  })
                                                                ],
                                                                1
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c("route-extras", {
                                                attrs: { route: route }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    "padding-left": "5px",
                                                    "padding-right": "30px",
                                                    "padding-top": "10px"
                                                  }
                                                },
                                                [
                                                  _c("v-slider", {
                                                    staticClass:
                                                      "route-opacity-slider",
                                                    attrs: {
                                                      min: 0,
                                                      max: 1,
                                                      "append-icon": "opacity",
                                                      "thumb-size": 24,
                                                      "thumb-label": "always",
                                                      title: _vm.$t(
                                                        "routeDetails.routeOpacity"
                                                      ),
                                                      step: 0.1
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        return _vm.routeOpacityChanged(
                                                          routeIndex
                                                        )
                                                      }
                                                    },
                                                    model: {
                                                      value:
                                                        route.properties
                                                          .opacity,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          route.properties,
                                                          "opacity",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "route.properties.opacity"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    }),
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d269ae30", { render: render, staticRenderFns: staticRenderFns })
  }
}